import styled from 'styled-components';

export const StyledSkeletonSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 3rem 0;
`;

export const LineGroupSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  gap: 1rem;
  width: 10rem;
`;
